<template lang="pug">
Wrapper(v-bind="$props") 
  slot
</template>

<script>
import { transparentize, darken, invert } from "polished"
import styled from "vue-styled-components"

const Props = {
  full: Boolean,
  fs: Boolean,
  zi: String,
  color: String,
  bg: String,
  bgd: String,
  bgo: String,
  reverse: Boolean
}
export const Wrapper = styled("div", Props)`
  overflow: hidden;
  ${props => props.full && "width:100%; height:100%;"}
  ${props => props.fs && "position:absolute !important; top:0; left:0; bottom:0; right:0;"}
  ${props => props.zi && "z-index:" + props.zi + ";"}
     
  color: ${props => {
    return !props.color ? (props.reverse ? props.theme.color.surface : props.theme.color.onSurface) : props.color
  }};
  

  /* Background */
  background : ${props => {
    let gradient,
      from,
      to,
      angle = props.bgd || "0",
      transparent = props.bgo || 1

    if (typeof props.bg === "undefined") return "transparent;"

    if (!props.bg.includes("overlay")) {
      if (props.bg === "primary") return `${transparentize(1 - transparent, props.theme.color.primary)};`
      else if (props.bg === "transparent") return "transparent;"
      else if (props.bg === "darken")
        return `${transparentize(1 - transparent, darken(0.05, props.reverse ? props.theme.color.onSurface : props.theme.color.surface))};`
      else if (props.bg === "") return `${transparentize(1 - transparent, props.reverse ? props.theme.color.onSurface : props.theme.color.surface)};`
      else return `${transparentize(1 - transparent, props.bg)};`
    }

    from = transparentize(1 - transparent, props.reverse ? props.theme.color.onSurface : props.theme.color.surface)
    to = transparentize(1 - transparent, props.theme.color.primary)

    if (props.bg === "overlay") gradient = `-linear-gradient(${angle}deg, ${from} 0%, ${to} 100%);`
    else if (props.bg === "overlayFrom") gradient = `-linear-gradient(${angle}deg, ${from} 0%, transparent 100%);`
    else if (props.bg === "overlayTo") gradient = `-linear-gradient(${angle}deg, transparent 0%, ${to} 100%);`
    else if (props.bg === "overlayToSurface") gradient = `-linear-gradient(${angle}deg, transparent 0%, ${from} 100%);`

    return "-webkit" + gradient + ";"
  }};
 
  .text-muted {
    ${props => props.reverse && "color:" + transparentize(0.45, props.theme.color.surface) + "!important;"}
  }
 
  .border,
  .border-left,
  .border-right,
  .border-top,
  .border-bottom {
    ${props => props.reverse && "border-color:" + invert(props.theme.color.border) + "!important;"}
  }
`
export default {
  name: "pr-wrapper",
  components: {
    Wrapper
  },
  props: {
    ...Props
  }
}
</script>
